import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Modal, Button } from 'antd';
import { toggleVerifyDialog } from '@store/serviceIntegrations/integrationForm/actions';
import { showVerifyDialogSelector } from '@store/serviceIntegrations/integrationForm/selectors';
import { StyledPara } from './styled';

interface IProps {
  onVerify: () => void;
  partnerDetails: any;
}

function VerifyModal({
  onVerify,
  partnerDetails,
}: IProps) {
  const dispatch = useDispatch();

  const visible = useSelector(showVerifyDialogSelector);

  const onConfirm = () => {
    dispatch(toggleVerifyDialog());
    onVerify();
  };

  const onCancel = () => {
    dispatch(toggleVerifyDialog());
  };

  const footerButtons = [
    (
      <Button
        key="discard"
        onClick={onCancel}
      >
        Cancel
      </Button>
    ),
    (
      <Button
        key="save"
        type="primary"
        onClick={onConfirm}
      >
        Confirm
      </Button>
    ),
  ];

  return (
    <Modal
      title={`Confirm ${partnerDetails.partnerName} Configuration`}
      width="550px"
      open={visible}
      onCancel={onCancel}
      footer={footerButtons}
    >
      <StyledPara>
        <p>
          To validate the
          {` ${partnerDetails.partnerName} `}
          configuration, a test incident has been sent to
          {` ${partnerDetails.partnerName}`}
          . Click Confirm if you received the
          {` ${partnerDetails.partnerName} `}
          incident notification.
          Otherwise, re-check the configuration details.
        </p>
      </StyledPara>
    </Modal>
  );
}

export default VerifyModal;
